import { render } from "./SearchHelper.vue?vue&type=template&id=a578cd84"
import script from "./SearchHelper.vue?vue&type=script&lang=js"
export * from "./SearchHelper.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__